import { Component, Input, Output, EventEmitter } from '@angular/core';

export type AlertOptions = {
    title?: string;
    message?: string;
    icon?: string;
    class?: string;
    showCloseButton?: boolean;
    asideContent?: boolean;
};

@Component({
    selector: 'ok-alert',
    template: `
        <div class="alert" [ngClass]="alert.class">
            @if (alert.icon) {
                <div class="alert-aside">
                    <i class="ico-moon" [ngClass]="alert.icon"></i>
                </div>
            }
            <div class="alert-main">
                @if (alert.title) {
                    <h3>{{ alert.title }}</h3>
                }
                @if (alert.message) {
                    <p>{{ alert.message }}</p>
                }
                <ng-content select="[alertMainContent]"> </ng-content>
            </div>
            @if (alert.showCloseButton) {
                <button class="alert-dismiss" (click)="onClose.emit()">
                    <i class="ico-moon ico-moon-cross2"></i>
                </button>
            }
            @if (alert.asideContent) {
                <div class="alert-aside">
                    <ng-content select="[alertAside]"> </ng-content>
                </div>
            }
        </div>
    `,
    standalone: false
})
export class OkAlertComponent {
    @Input()
    alert: AlertOptions;

    @Output()
    readonly onClose: EventEmitter<void> = new EventEmitter();
}
